import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';
import { microsoftCloudSchema } from '../../lib/microsoft';

export type MicrosoftEntraConnectorConfig = typeof MicrosoftEntraConnector._.Config;

export const MicrosoftEntraConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.MicrosoftEntra,
  logoPath: 'images/microsoft-entra-logo.svg',
  categories: [IntegrationConnectorCategory.Identity],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.AppRegistrationClientSecret,
      configSchema: z.object({
        cloud: microsoftCloudSchema,
        tenantId: z.uuid(),
        clientId: z.uuid(),
      }),
      encryptedConfigSchema: z.object({
        clientSecret: z.string().min(1),
      }),
    }),
  ]),
});
